import { useContext } from 'react'
import { BreadcrumbContext } from '../../context/Breadcrumbs/BreadcrumbContext'

const useBreadcrumbOptions = () => {
  return useContext(BreadcrumbContext)
}

export default useBreadcrumbOptions
